module.exports = __webpack_public_path__ + "static/media/boxes-alt.ec5da426.svg";